export const VALUE_VIEW_BY = {
  CHART: 'Chart',
  TABLE: 'Table',
}

export const TYPE_SELECT_VIEW_BY = [
  {
    label: 'portfolioScore.chart',
    isI18n: true,
    value: VALUE_VIEW_BY.CHART,
  },
  {
    label: 'portfolioScore.table',
    isI18n: true,
    value: VALUE_VIEW_BY.TABLE,
  },
]

export const VALUE_IDS_TABLE = {
  FILTERED: 'FILTERED',
  LARGEST: 'LARGEST',
  LOWEST: 'LOWEST',
  PORTFOLIO_FIRST: 'PORTFOLIO_FIRST',
  PORTFOLIO_SECOND: 'PORTFOLIO_SECOND',
}

export const IDS_TABLE = [
  'FILTERED',
  'LARGEST',
  'LOWEST',
  'PORTFOLIO_FIRST',
  'PORTFOLIO_SECOND',
]

export const IDS_TREND_BY_PORT = {
  FILTERED: 1,
  LARGEST: 2,
  LOWEST: 3,
  PORTFOLIO_FIRST: 4,
  PORTFOLIO_SECOND: 5,
}

export const DATA_CHECKBOX = Object.values(IDS_TREND_BY_PORT).map(
  (item) => `data${item}`,
)

const COLORS_CHART = ['#006AA6', '#74B49A', '#00A8B5', '#C06C84', '#F49966']

export const TYPE_CHART_RISK = Object.values(IDS_TREND_BY_PORT).map(
  (item, index) => ({
    id: item,
    color: COLORS_CHART[index],
    dataKey: `data${item}`,
    dataFloatBar: `dataFloatBar${item}`,
  }),
)
